import { PlusIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { usePurchaseOrderDocumentDialog } from '@/features/purchase-order/hooks/use-purchase-order-document-dialog';
import { PurchaseOrderDocumentDialog } from '@/features/purchase-order/purchase-order-document-dialog';
import { PurchaseOrderDocumentsTable } from '@/features/purchase-order/purchase-order-documents-table';

type PurchaseOrderDocumentsProps = {
  purchaseOrderId: string;
};

export function PurchaseOrderDocuments({
  purchaseOrderId,
}: PurchaseOrderDocumentsProps) {
  const { t } = useTranslation('purchaseOrder');
  const { dialogOpen, onDialogOpenChange, openAddDocumentDialog } =
    usePurchaseOrderDocumentDialog();

  return (
    <div className='flex min-h-0 flex-1 flex-col gap-4'>
      <div className='flex justify-end'>
        <Button onClick={openAddDocumentDialog} type='button' variant='outline'>
          <PlusIcon aria-hidden className='size-4' />
          {t('documentsAddButton')}
        </Button>
      </div>

      <div className='min-w-0 flex-1'>
        <PurchaseOrderDocumentsTable purchaseOrderId={purchaseOrderId} />
      </div>

      <PurchaseOrderDocumentDialog
        onOpenChange={onDialogOpenChange}
        open={dialogOpen}
        purchaseOrderId={purchaseOrderId}
      />
    </div>
  );
}
